import styled from '@emotion/styled';
import { color_colors_ocean, color_shades_darker } from '../../../../../../shared/constants/colors';

// Compact pills for Spark form state: what's saved, what's sandbox, and the button to update it

const pill = `
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 26px;
    padding: 0 12px;
    border-radius: 13px;
    font-family: Muli;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
`;

export type PillTone = 'done' | 'warning' | 'missing';

export const StatusPill = styled.span<{ tone: PillTone }>`
    ${pill}
    color: ${props => props.tone === 'done' ? '#2f855a' : props.tone === 'warning' ? '#b7791f' : color_shades_darker};
    background-color: ${props => props.tone === 'done' ? 'rgba(56, 161, 105, 0.12)' : props.tone === 'warning' ? 'rgba(214, 158, 46, 0.15)' : '#edf2f7'};
`;

export const SparkFormButton = styled.button`
    ${pill}
    border: 1px solid ${color_colors_ocean};
    background-color: #ffffff;
    color: ${color_colors_ocean};
    cursor: pointer;
    transition: all 0.15s ease-in-out;

    &:hover:not(:disabled) {
        background-color: ${color_colors_ocean};
        color: #ffffff;
    }

    &:disabled {
        opacity: 0.6;
        cursor: default;
    }
`;

export const PillError = styled.span`
    max-width: 240px;
    font-family: Muli;
    font-size: 11px;
    color: #c53030;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
